import lodash from 'lodash';
import * as XLSX from 'xlsx';

/**
 * 将 JSON 数据导出为 CSV 文件
 * @param jsonArray
 * @param keyMap
 */
export function downloadToCsv(jsonArray: object[], keyMap: object, fileName = '下载') {
  // \uFEFF 是为解决中文乱码问题
  let csvContent = 'data:text/csv;charset=utf-8,\uFEFF';

  if (jsonArray && jsonArray.length) {
    const keys = lodash.uniq(
      lodash.flatten(
        jsonArray.map((rowData) => {
          return Object.keys(rowData);
        }),
      ),
    );
    jsonArray.forEach((rowData: any, index: number) => {
      if (index == 0) {
        // 第一行，保存字段头信息
        const headerRow = keys
          .map((key) => {
            // @ts-ignore
            return (keyMap && keyMap[key]) || key;
          })
          .join(',');
        csvContent += `${headerRow}\r\n`;
      }
      const row = keys
        .map((key) => {
          // @ts-ignore
          const converter = keyMap['_' + key];
          if (converter) {
            // _ 开头的是转换函数，用于将英文、数字等转换成中文
            return converter(lodash.get(rowData, key, '') + '' ?? '');
          } else {
            console.info('no converter', key);
            return JSON.stringify(lodash.get(rowData, key, '') ?? '');
          }
        })
        .join(',');
      csvContent += `${row}\r\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const a = document.createElement('a');
    a.href = encodedUri;
    a.target = '_blank';
    a.download = `${fileName}.csv`;
    a.click();
  } else {
    console.error('无数据，无法下载');
  }
}

/**
 * 将 JSON 数据导出为 Excel 文件（.xlsx）
 * @param jsonArray
 * @param keyMap
 * @param fileName
 */
export function downloadToExcel(jsonArray: object[], keyMap: object, fileName = '下载') {
  if (!jsonArray || jsonArray.length === 0) {
    console.error('无数据，无法下载');
    return;
  }
  const keys = Object.keys(keyMap).filter(k => !k.startsWith('_'));
  const header = keys.map(k => (keyMap as any)[k] || k);
  const data = jsonArray.map(row => keys.map(k => (row as any)[k]));
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
